import { BranchParams } from 'react-native-branch';

import { CustomEventNames, logEvent } from 'state/amplitude';
import { EventTypes } from 'state/amplitude/types';
import { logger } from 'utils/logger';

export const categorizeTraffic = (_params: BranchParams) => {
  // Destination: what page is loading?
  const destination = window.location.href ?? null;
  // Source: who sent us this traffic?
  const source = document.referrer ?? null;
  // If there is no known source, or the source is the same origin as the destination,
  // we judge the traffic as organic.
  let isOrganic = !source;
  if (source) {
    // edge case for if we have a fully qualified https link from one page to another somewhere
    try {
      const destinationOrigin = new URL(destination).origin;
      const sourceOrigin = new URL(source).origin;
      isOrganic = destinationOrigin === sourceOrigin;
    } catch {
      logger.error({ message: 'unexpected source or destination', source, destination });
      isOrganic = false;
    }
  }
  // TODO: verify the behavior of Braze universal email links like <a href="https://www.bk.com/menu" universal="true">
  // Expectation is a referrer of either burgerking.app.link/abc123 or possibly a click tracking domain like ablinks.com
  // https://www.braze.com/docs/user_guide/message_building_by_channel/email/universal_links/#universal-links-app-links-and-click-tracking
  logEvent(CustomEventNames.APP_OPEN, EventTypes.Other, { source, destination, isOrganic });
};
